import { createTheme, adaptV4Theme } from '@mui/material/styles';
import palette from './palette';
import typography from './typography';

/**
 * 🔴 Les surcharges qui font TENIR le plancher de 16 px.
 *
 * `typography.js` le pose, mais deux composants de MUI appliquent leur propre
 * taille par-dessus, et le thème n'y peut rien seul. Relevé en mesurant les
 * tailles réellement rendues sur chaque écran, pas en lisant le thème —
 * `scripts/screenshots/audit-tailles.mjs` dans le dépôt du site.
 */
const theme = createTheme(adaptV4Theme({
  palette,
  typography,
  zIndex: {
    appBar: 1200,
    drawer: 1100,
  },
  shape: {
    borderRadius: 1,
  },
}), {
  // ⚠️ HORS de `adaptV4Theme`, en second argument de `createTheme`.
  // L'adaptateur ne connaît que les clés de MUI v4 — `overrides` et `props` —
  // et laisse tomber `components` SANS RIEN DIRE. Les surcharges étaient
  // écrites, lisibles dans le diff, et n'avaient aucun effet : l'audit des
  // tailles rendait exactement les mêmes quatre textes sous 16 px.
  components: {
    MuiInputLabel: {
      styleOverrides: {
        // ⚠️ MUI réduit l'étiquette flottante à 75 % de sa taille quand elle
        // remonte au-dessus du champ. Une étiquette de 16 px s'affichait donc
        // à 12 px — et c'est le seul texte qui dit à quoi sert le champ une
        // fois qu'on a commencé à écrire dedans.
        //
        // On compense la réduction plutôt que de la supprimer : sans elle,
        // l'encoche de la bordure serait calculée pour une autre largeur et le
        // trait passerait au travers du texte.
        shrink: {
          fontSize: '21.33px',
        },
      },
    },
    MuiTablePagination: {
      styleOverrides: {
        // « 20 lignes », « 1-5 de 5 » et les libellés voisins : MUI les fixe à
        // 0,875 rem sans passer par la typographie du thème.
        root: {
          fontSize: '1rem',
        },
        selectLabel: {
          fontSize: '1rem',
        },
        displayedRows: {
          fontSize: '1rem',
        },
        select: {
          fontSize: '1rem',
        },
      },
    },
  },
});

export default theme;
